/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { SessionState } from './SessionState';
import { YospaceAdsSessionFactory } from './YospaceAdsSessionFactory';
import { YospaceAdsSession, PlaybackMode } from './YospaceAdsSession';
import { YospaceAdsPlayerFactory } from './YospaceAdsPlayerFactory';
import { findJavaScriptResourceURL } from './internal/AdUtil';
import { YospaceInitializationData, Status } from './model/YospaceInitializationData';

const version = '__buildVersion__';

export {
  YospaceAdsPlayerFactory,
  YospaceAdsSessionFactory,
  YospaceAdsSession,
  SessionState,
  PlaybackMode,
  YospaceInitializationData,
  Status,
  findJavaScriptResourceURL,
  version,
};
